import { render, staticRenderFns } from "./ProjectInProgressLifecycleSetter.vue?vue&type=template&id=21f4ab3c"
import script from "./ProjectInProgressLifecycleSetter.vue?vue&type=script&lang=ts"
export * from "./ProjectInProgressLifecycleSetter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports